import {
  multiIcon,
  pictureChoice,
  rankOrderIcon,
  sliderIcon,
  StarIcon,
  textFiled,
} from "assets/icons";
import { generateUniqueId, surveyFormValue } from "constant/staticData";
import React, { useEffect, useRef, useState, useTransition } from "react";
import { useTranslation } from "react-i18next";
import { scrollPage, scrollPage1 } from "utils/commonHelper";
import { toastMessage } from "utils/toastMessageHelper";

const DropdownQuestionType = ({
  blockArray,
  showDropdown,
  selectedBlock,
  setBlockArray,
  setShowDropdown,
  setSurveyQuestionArray,
}) => {
  const divRef = useRef(null);

  const { t } = useTranslation();

  // Survey Type Handler
  const questionTypes = [
    {
      type: "Multiple Choice Question",
      icon: multiIcon,
      alt: "Multiple Choice Icon",
      description:
        "This will let participants pick from a list of multiple choice options that you provide.",
      className: "multiple_choice",
      questionValue: "multiple",
    },
    {
      type: "Text Field Response",
      icon: textFiled,
      alt: "Text Field Icon",
      description:
        "Let participants leave an open-ended response for whatever question you have.",
      className: "text_field_response",
      questionValue: "text",
    },
    {
      type: "Picture Choice",
      icon: pictureChoice,
      alt: "Picture Choice Icon",
      description:
        "Easily split test multiple images. Participants will select one and then leave feedback.",
      className: "picture_choice",
      questionValue: "image",
    },
    {
      type: "Rank Order",
      icon: rankOrderIcon,
      alt: "Rank Order Icon",
      description:
        "Allows respondents to arrange a list of items in order of preference, importance, or priority.",
      className: "rank_order",
      questionValue: "rankorder",
    },
    {
      type: "Slider",
      icon: sliderIcon,
      alt: "Slider Icon",
      description:
        "Respondents can assign a rank or value by dragging a slider along a scale.",
      className: "slider",
      questionValue: "slider",
    },
    {
      type: "Rating",
      icon: StarIcon,
      alt: "Star Icon",
      description:
        "Respondents can assign a rank or value by dragging a slider along a scale.",
      className: "Star",
      questionValue: "rating",
    },
  ];

  // const totalQuestions = allSections.reduce((total, section) => {
  //   return total + (section.questions ? section.questions.length : 0);
  // }, 0);

  const getData = (type, updatedList) => {
    // Ensure selectedBlock exists
    if (!updatedList[selectedBlock]) {
      updatedList[selectedBlock] = [];
    }

    const option = {
      // questionNumber: 0,
      questionType: type,
      id: updatedList[selectedBlock].length + 1,
      questionNumber: updatedList[selectedBlock].length + 1, // Will be updated later
      required: false,

      setting: {
        optionType: "single",
        imagePositon: "above",
        textAreaMin: 0,
        textAreaMax: 500,
        sliderMin: 0,
        sliderMax: 100,
        rankCount: 4,
        starCount: 5,
      },
      ...(["multiple", "image", "rating", "slider"].includes(type) && {
        option: Array.from({ length: 2 }, (_, index) => ({
          optionValue: "",
          optionImage: "",
          questionNumber: "",
          rank: index + 1,
          isSurveyEnd: false,
          isBlockEnd: false,
        })),
      }),

      ...(type === "rankorder" && {
        option: Array.from(
          { length: surveyFormValue?.SURVEY_RANK_COUNT || 4 },
          (_, index) => ({
            optionValue: "",
            optionImage: "",
            questionNumber: "",
            rank: index + 1,
          })
        ),
      }),
    };

    // Push the new question into the selected block
    const newUpdatedList = { ...updatedList }; // Create a new copy
    newUpdatedList[selectedBlock] = [...newUpdatedList[selectedBlock], option];

    // Recalculate question numbers globally
    // let questionCounter = 1;
    // Object.values(newUpdatedList).forEach((section) => {
    //   section.forEach((question) => {
    //     question.questionNumber = questionCounter++; // Assign new global numbering
    //   });
    // });

    return newUpdatedList;
  };

  // Survey Question List Handler By himanshu
  const surveyQuestionHandler = (value) => {
    let blockUpdatedClone = blockArray?.map((el) => el);
    let blockIndex = blockArray.findIndex((el) => el?.name === selectedBlock);

    blockUpdatedClone[blockIndex] = {
      ...blockUpdatedClone[blockIndex],
      totalQuestion: blockUpdatedClone[blockIndex]?.totalQuestion + 1,
    };

    setBlockArray(blockUpdatedClone);

    setSurveyQuestionArray((prevList) => {
      // Create a deep copy to avoid mutating state directly
      const updatedList = { ...prevList };

      // Ensure selectedBlock exists in updatedList
      if (!updatedList[selectedBlock]) {
        updatedList[selectedBlock] = [];
      }

      // Generate new question data
      const newList = getData(value, updatedList);

      return { ...newList }; // Return a new object to trigger re-render
    });
  };

  useEffect(() => {
    if (showDropdown) {
      setTimeout(() => {
        scrollPage1("up", divRef);
      }, 100);
    }
  }, [showDropdown]);

  //*********************** Handle HTML CODE *****************//
  return showDropdown ? (
    <div className="_card" ref={divRef}>
      <h4>{t(`CUSTOMIZATION_QUESTION.selectQuestionType`)}</h4>
      <div
        className="question_type_card_wrap"
        onClick={() => blockArray.length && setShowDropdown(false)}
      >
        {questionTypes.map((question, index) => (
          <div
            key={`${question.className}-${index}`}
            className={`question_type_card ${question.className}`}
            onClick={() => surveyQuestionHandler(question?.questionValue)}
          >
            <h5>
              <img src={question.icon} alt={question.alt} />
              {t(`CUSTOMIZATION_QUESTION.questionType-type-${index}`)}
            </h5>
            <p>
              {t(`CUSTOMIZATION_QUESTION.questionType-description-${index}`)}
            </p>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default DropdownQuestionType;
